/* LUVA cart. One handler for every add-to-cart form in a LUVA section.
   Posts to /cart/add.js, then opens the theme's own cart drawer.
   Without JavaScript the form still submits normally, so nothing is lost. */
(function () {
  /* An error that only reaches the console is an error the shopper never
     learns about, so it gets a line inside the form. */
  function say(form, text) {
    var box = form.querySelector('[data-luva-msg]');
    if (!box) {
      if (!text) return;
      box = document.createElement('p');
      box.className = 'luva-cart-msg';
      box.setAttribute('data-luva-msg', '');
      box.setAttribute('role', 'status');
      form.appendChild(box);
    }
    box.textContent = text;
    box.hidden = !text;
  }

  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart-lines:update', { bubbles: true }));
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  function submit(form) {
    var btn = form.querySelector('[data-luva-add-btn]');
    /* The button may be an icon, so the whole markup is kept and restored.
       Replacing textContent threw the svg away on the first click. */
    var markup = btn ? btn.innerHTML : '';
    var isIcon = btn ? btn.textContent.trim() === '' : false;
    var items = [];

    form.querySelectorAll('input[name="id"], input[data-luva-id]').forEach(function (i) {
      var id = Number(i.value);
      var qty = Number(i.getAttribute('data-qty') || 1);
      if (id) items.push({ id: id, quantity: qty });
    });
    if (!items.length) return false;

    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (!isIcon) btn.textContent = btn.getAttribute('data-busy') || '…';
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var failed = !!(res && res.status);

        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = markup;
          if (!failed && !isIcon) {
            var done = btn.getAttribute('data-done');
            if (done) {
              btn.textContent = done;
              setTimeout(function () { btn.innerHTML = markup; }, 1600);
            }
          }
        }

        if (failed) {
          say(form, (res && res.description) || (res && res.message) || '');
        } else {
          say(form, '');
          openDrawer();
        }
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.innerHTML = markup;
        }
        say(form, form.getAttribute('data-luva-error') || luvaT('cart_error_generic', 'That did not work. Please try again.'));
      });

    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-luva-add]');
    if (!form) return;
    e.preventDefault();
    submit(form);
  });
})();
